import createApiClient from "./api";

const api = createApiClient("/punch-lists");

export const fetchPunchLists = async (projectId, page = 1, pageSize = 10) => {
  const token = localStorage.getItem("token");
  const response = await api.get("", {
    params: {
      project_id: projectId,
      skip: (page - 1) * pageSize,
      limit: pageSize,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const { data, total } = response.data;
  return { punchLists: data, total };
};

export const createPunchList = async (punchList) => {
  const token = localStorage.getItem("token");
  const response = await api.post("", punchList, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updatePunchList = async ({ punchListId, punchList }) => {
  const token = localStorage.getItem("token");
  const response = await api.put(`/${punchListId}`, punchList, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deletePunchList = async (punchListId) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(`/${punchListId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchPunchListItems = async (
  punchListId,
  page = 1,
  pageSize = 10,
  filters = {}
) => {
  const token = localStorage.getItem("token");
  const cleaned = {};
  if (filters && typeof filters === "object") {
    Object.entries(filters).forEach(([k, v]) => {
      if (v == null) return;
      const s = typeof v === "string" ? v.trim() : v;
      if (s === "" || (Array.isArray(s) && s.length === 0)) return;
      cleaned[k] = typeof v === "string" ? v.trim() : v;
    });
  }
  const response = await api.get(`/${punchListId}/items`, {
    params: {
      skip: (page - 1) * pageSize,
      limit: pageSize,
      filters: JSON.stringify(cleaned),
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const { data, total } = response.data;
  return { items: data, total };
};

export const createPunchListItem = async ({ punchListId, punchListItem, emailNotifications = true }) => {
  const token = localStorage.getItem("token");
  const response = await api.post(
    `/${punchListId}/items?email_notification=${emailNotifications}`, 
    punchListItem, 
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const linkPunchListItemToDrawing = async (
  punchListId,
  punchListItemId,
  drawingId,
  x,
  y,
) => {
  const token = localStorage.getItem("token");
  const response = await api.patch(
    `/${punchListId}/items/${punchListItemId}/drawing-link`,
    {
      drawing_id: drawingId,
      x,
      y,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const unlinkPunchListItemFromDrawing = async (
  punchListId,
  punchListItemId,
  drawingId,
  x,
  y,
) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(
    `/${punchListId}/items/${punchListItemId}/drawing-link`,
    {
      data: {
        drawing_id: drawingId,
        x,
        y,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const updatePunchListItem = async ({
  punchListId,
  punchListItemId,
  punchListItem,
  emailNotifications = true,
}) => {
  console.log(punchListItem);
  const token = localStorage.getItem("token");
  const response = await api.put(
    `/${punchListId}/items/${punchListItemId}?email_notification=${emailNotifications}`,
    punchListItem,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};


export const deletePunchListItem = async ({ punchListId, punchListItemId }) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(
    `/${punchListId}/items/${punchListItemId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const fetchNextPunchListItemNumber = async (punchListId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/${punchListId}/next-number`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const fetchPunchListItemDetail = async (
  punchListId,
  punchListItemId,
) => {
  const token = localStorage.getItem("token");
  const response = await api.get(
    `${punchListId}/items/${punchListItemId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const postPunchListItemResponse = async (
  punchListId,
  punchListItemId,
  { response, attachments = [] },
) => {
  const token = localStorage.getItem("token");
  const result = await api.post(
    `${punchListId}/items/${punchListItemId}/respond`,
    { response, attachments },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return result.data;
};

export const deletePunchListItemResponse = async (
  punchListId,
  punchListItemId,
  responseId,
) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(
    `${punchListId}/items/${punchListItemId}/responses/${responseId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const downloadPunchListItemReport = async (punchListId, punchListItemId) => {
  const token = localStorage.getItem("token");
  const now = new Date();
  const localDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  const response = await api.get(
    `/${punchListId}/items/${punchListItemId}/download-report`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        local_date: localDate,
      },
      responseType: "blob",
    },
  );
  return response.data;
};

export const downloadPunchListReport = async (punchListId, filters = {}) => {
  const token = localStorage.getItem("token");
  const now = new Date();
  const localDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  const cleaned = {};
  if (filters && typeof filters === "object") {
    Object.entries(filters).forEach(([k, v]) => {
      if (v == null) return;
      const s = typeof v === "string" ? v.trim() : v;
      if (s === "" || (Array.isArray(s) && s.length === 0)) return;
      cleaned[k] = typeof v === "string" ? v.trim() : v;
    });
  }

  const response = await api.get(`/${punchListId}/download-report`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      local_date: localDate,
      filters: JSON.stringify(cleaned),
    },
    responseType: "blob",
  });
  return response.data;
};

export const deletePunchListItemResponseAttachment = async (
  punchListId,
  punchListItemId,
  responseId,
  attachmentId,
) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(
    `${punchListId}/items/${punchListItemId}/responses/${responseId}/attachments/${attachmentId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};
